import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './sticky-tooltip.magic.css.js';
import script from './sticky-tooltip.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sticky-tooltip",attrs:{"part":"sticky-tooltip"}},[_c('div',{staticClass:"clickable",attrs:{"part":"clickable"},on:{"click":function($event){return _vm.openTooltip()}}},[_vm._t("clickable")],2),_vm._v(" "),_c('transition',{attrs:{"name":"fade-in"}},[(_vm.isOpen)?_c('div',{staticClass:"content",attrs:{"part":"content"}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"close","part":"icon"},on:{"click":function($event){return _vm.closeTooltip()}}}),_vm._v(" "),_vm._t("content")],2):_vm._e()])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-55f8f4de_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-55f8f4de";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
